export const DEFAULT_HIGH_THRESHOLD = 70;
export const DEFAULT_MINUTES_TO_NEXT_TASK = 60;



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/constants/parks.constants.ts